<template>
  <div class="section">
  	Overview
  </div>
</template>

<script>
export default {
  name: 'overview'
}
</script>
